const INITIAL_STATE = {
    root: "Me"
};

const Reducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        default:
            return state;
    }
}

export default Reducer;


// WEBPACK FOOTER //
// ./src/reducers/app.js